import { render, staticRenderFns } from "./wangEmitter.vue?vue&type=template&id=b2a158f2&scoped=true"
import script from "./wangEmitter.vue?vue&type=script&lang=js"
export * from "./wangEmitter.vue?vue&type=script&lang=js"
import style0 from "./wangEmitter.vue?vue&type=style&index=0&id=b2a158f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a158f2",
  null
  
)

export default component.exports